import React from "react";
import { string, number, bool } from "prop-types";
import { useTranslation } from "@lib/i18n";

import { getIsLOAJourneySelected } from "@shared/v2/lib/getIsLOAJourneySelected";
import { getIsLeasingJourneySelected } from "@shared/v2/lib/getIsLeasingJourneySelected";

const FinancingTitle = ({
  isGenericHeader = false,
  journey,
  vehicleQuantity,
}) => {
  const { t } = useTranslation();

  const isLeasingJourney = getIsLeasingJourneySelected(journey);
  const isLoaJourney = getIsLOAJourneySelected(journey);

  const contentKey = isLeasingJourney
    ? "basket.myFunding"
    : vehicleQuantity > 1
    ? "basket.myPayment.plural"
    : "basket.myPayment.singular";

  const className = !isGenericHeader
    ? "lg:text-lg lowercase font-semibold text-primaryDark"
    : "";

  return (
    <span className={className}>
      {t(contentKey)}
      {isLoaJourney && <span className="text-3xl">*</span>}
    </span>
  );
};

FinancingTitle.propTypes = {
  isGenericHeader: bool,
  journey: string.isRequired,
  vehicleQuantity: number,
};

export default FinancingTitle;
